import { createTheme } from '@mui/material/styles';

const RSTheme = createTheme({
  status: {
    danger: 'red',
  },
});

export default RSTheme
